<div class="col-12 mt-3" *ngIf="item">
    <div class="row card-itinerary p-0  pl-2"

    [ngStyle]="{'border': getSyncStatusStyle(item), 'background-color': itemHasPenality === true ? '#fff5f6' : 'white'}"

    >
        <!-- icono actividad registrada -->
        <div class="d-flex flex-column justify-content-between align-items-center content-icons p-0 mt-4">
            <div class="icon-itinerary-activity  d-flex justify-content-center align-items-center" (click)="select()">
                <img width="26px"
                      [src]="getIconCategory(item.item.categoryName, item)"
                    alt="">
            </div>
            <div *ngIf="item.item?.source" [ngStyle]="{'background-color': getClientsSettingAppBooking.clients_setting_global?.color_main_1}"
                  class="mb-3 py-1 px-2" style="border-radius: 4px;">
              <p class="booking-source mb-0">{{item.item?.source}}</p>
            </div>
        </div>
        <!-- item detail -->
        <div class="d-flex content-detail px-3">
            <usb-item-details
                [itinerary]="itinerary"
                [reservation]="reservation"
                [modifications]= "modifications"
                [item]="item.item"
                [selected]="selected"
                [clientsSettingAppBooking]="getClientsSettingAppBooking"
                [currencies]="currencies"
                [currencyAgency]="currencyAgency"
                [status]="status"
                (delete)="deleteItem($event)"
                (cancel)="cancelReservations($event)"
                (reSearch)="reSearch($event)"
                (loadingCancel)="loadingSplashCancel($event)"

                style="width: 100% !important;"
            >
            </usb-item-details>
        </div>
        <!-- item status -->
        <div class="d-flex content-status p-0">
            <usb-item-status
            #itemStatus
            *ngIf="_status"
            [reservation]="reservation"
            [modifications]= "modifications_"
            [currencies]="currencies"
            [currencyAgency]="currencyAgency"
            (accept)="acceptNewPrice()"
            (reserve)="reserveItem()"
            (delete)="deleteItem($event)"
            (reSearch)="reSearch($event)"
            [status]="_status"
            [item]="item"
            [itemProduct]="itemProduct"
            [indexItemProduct]="index"
            [showTextChangeDetailsProducts]="showTextChangeDetailsProducts"
            (update)="updateItem($event)"
            [selected]="selected"
            [partialReserve]="partialReserve"
            [clientsSettingAppBooking]="getClientsSettingAppBooking"
            (itemToPartial)="_itemToPartial($event)"
            [changePriceFromReserve]="changePriceFromReserve"
            (reloadItinerary)="_reloadItinerary()"
            (partialSelection)="onPartialSelection($event)"
            (hasPenalityEmmiter)="hasPenality($event)"
            style="width: 100% !important;">
        </usb-item-status>
        </div>
    </div>
</div>
